import { useQuery } from '@tanstack/react-query';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { getConfig } from '@edx/frontend-platform';

const fetchCourseDetails = async (courseId) => {
  if (!courseId) return null;
  
  const url = `${getConfig().LMS_BASE_URL}/api/courses/v1/courses/${courseId}`;
  try {
    const { data } = await getAuthenticatedHttpClient().get(url);
    return data;
  } catch (error) {
    console.error('Error fetching course details:', error);
    return null;
  }
};

const useFetchCourseDetails = (courseId) => {
  return useQuery({
    queryKey: ['courseDetails', courseId],
    queryFn: () => fetchCourseDetails(courseId),
    enabled: !!courseId,
  });
};

export default useFetchCourseDetails; 